'use client';

import { GenericCardIcon, PayPalBrandmark } from './icons';

export type PaymentMethod = 'card' | 'paypal' | null;

interface PaymentMethodSelectorProps {
  selected: PaymentMethod;
  onSelect: (method?: 'card' | 'paypal') => void;
  disabled?: boolean;
}

export default function PaymentMethodSelector({
  onSelect,
  disabled = false,
}: PaymentMethodSelectorProps) {
  return (
    <div className="mb-3">
      <label className="block text-zinc-800 font-semibold mb-2">Choose a way to pay</label>
      <div className="grid grid-cols-2 gap-3">
        <button
          type="button"
          onClick={() => onSelect('card')}
          disabled={disabled}
          className="flex items-center justify-center gap-2 p-4 border-2 border-slate-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Pay with a credit card"
        >
          <GenericCardIcon className="w-8 h-6" />
          <span className="font-semibold text-sm">Credit card</span>
        </button>
        <button
          type="button"
          onClick={() => onSelect('paypal')}
          disabled={disabled}
          className="flex items-center justify-center gap-2 p-4 border-2 border-slate-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Pay with PayPal"
        >
          <PayPalBrandmark className="h-5 w-auto" />
        </button>
      </div>
    </div>
  );
}
